var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector474Stroke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.792893 1.24992C1.18342 0.8594 1.81658 0.8594 2.20711 1.24992L8 7.04282L13.7929 1.24992C14.1834 0.8594 14.8166 0.8594 15.2071 1.24992C15.5976 1.64045 15.5976 2.27361 15.2071 2.66414L9.41421 8.45703C8.63316 9.23808 7.36683 9.23808 6.58579 8.45703L0.792893 2.66414C0.402369 2.27361 0.402369 1.64045 0.792893 1.24992Z",
    fill: "#6E6D92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector474Stroke);
export default __webpack_public_path__ + "static/media/Vector 474 (Stroke).77aaa7248c5faecf0387bf852c1f7e58.svg";
export { ForwardRef as ReactComponent };